/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalReauthSubmissionStatus } from './PalReauthSubmissionStatus';
import {
    PalReauthSubmissionStatusFromJSON,
    PalReauthSubmissionStatusFromJSONTyped,
    PalReauthSubmissionStatusToJSON,
} from './PalReauthSubmissionStatus';
import type { PalReauthSubmissionStatusInfo } from './PalReauthSubmissionStatusInfo';
import {
    PalReauthSubmissionStatusInfoFromJSON,
    PalReauthSubmissionStatusInfoFromJSONTyped,
    PalReauthSubmissionStatusInfoToJSON,
} from './PalReauthSubmissionStatusInfo';
import type { UpdatePalReauthSubmissionRequestCaseManager } from './UpdatePalReauthSubmissionRequestCaseManager';
import {
    UpdatePalReauthSubmissionRequestCaseManagerFromJSON,
    UpdatePalReauthSubmissionRequestCaseManagerFromJSONTyped,
    UpdatePalReauthSubmissionRequestCaseManagerToJSON,
} from './UpdatePalReauthSubmissionRequestCaseManager';

/**
 * 
 * @export
 * @interface UpdatePalReauthSubmissionRequest
 */
export interface UpdatePalReauthSubmissionRequest {
    /**
     * 
     * @type {PalReauthSubmissionStatus}
     * @memberof UpdatePalReauthSubmissionRequest
     */
    status?: PalReauthSubmissionStatus;
    /**
     * 
     * @type {PalReauthSubmissionStatusInfo}
     * @memberof UpdatePalReauthSubmissionRequest
     */
    status_info?: PalReauthSubmissionStatusInfo;
    /**
     * 
     * @type {string}
     * @memberof UpdatePalReauthSubmissionRequest
     */
    external_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePalReauthSubmissionRequest
     */
    next_review_date?: string | null;
    /**
     * ID of an existing case manager to assign
     * @type {string}
     * @memberof UpdatePalReauthSubmissionRequest
     */
    case_manager_id?: string | null;
    /**
     * 
     * @type {UpdatePalReauthSubmissionRequestCaseManager}
     * @memberof UpdatePalReauthSubmissionRequest
     */
    case_manager?: UpdatePalReauthSubmissionRequestCaseManager;
}

/**
 * Check if a given object implements the UpdatePalReauthSubmissionRequest interface.
 */
export function instanceOfUpdatePalReauthSubmissionRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdatePalReauthSubmissionRequestFromJSON(json: any): UpdatePalReauthSubmissionRequest {
    return UpdatePalReauthSubmissionRequestFromJSONTyped(json, false);
}

export function UpdatePalReauthSubmissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePalReauthSubmissionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': !exists(json, 'status') ? undefined : PalReauthSubmissionStatusFromJSON(json['status']),
        'status_info': !exists(json, 'status_info') ? undefined : PalReauthSubmissionStatusInfoFromJSON(json['status_info']),
        'external_id': !exists(json, 'external_id') ? undefined : json['external_id'],
        'next_review_date': !exists(json, 'next_review_date') ? undefined : json['next_review_date'],
        'case_manager_id': !exists(json, 'case_manager_id') ? undefined : json['case_manager_id'],
        'case_manager': !exists(json, 'case_manager') ? undefined : UpdatePalReauthSubmissionRequestCaseManagerFromJSON(json['case_manager']),
    };
}

export function UpdatePalReauthSubmissionRequestToJSON(value?: UpdatePalReauthSubmissionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': PalReauthSubmissionStatusToJSON(value.status),
        'status_info': PalReauthSubmissionStatusInfoToJSON(value.status_info),
        'external_id': value.external_id,
        'next_review_date': value.next_review_date,
        'case_manager_id': value.case_manager_id,
        'case_manager': UpdatePalReauthSubmissionRequestCaseManagerToJSON(value.case_manager),
    };
}

